import BaseListagem from "components/BaseListagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import DefeitoFabricacaoService from "service/meta/producao/DefeitoFabricacaoService";
import { NumberMatchModeOptions, TextMatchModeOptions, filterApplyTemplate, numberFilterTemplate } from "utils/filterUtils";

const defeitoFabricacaoService = new DefeitoFabricacaoService();

export default function DefeitoFabricacaoListagem() {

    const [queryParameters] = useSearchParams();

    const [titulo, setTitulo] = useState<string>('Defeitos de fabricação');

    const defaultFilters: DataTableFilterMeta = {
        descricao: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        }
    }


    return (

        <BaseListagem ordenacao="descricao,ASC" service={defeitoFabricacaoService} urlService="/defeitoFabricacao" tituloPagina={titulo} defaultFilters={defaultFilters} showClearFilterButton nome="defeitoFabricacao" >
            <Column field="descricao" header="Descrição" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
        </BaseListagem>
    )
}